import classNames from "classnames";

export const Input = ({ className, ...props }) => {
    const inputClass = classNames(
        "border-none block w-full rounded-md border-gray-300 shadow-sm sm:text-sm bg-gray-50 focus:ring-gray-300 focus:border-gray-200",
        className
    );
    return <input className={inputClass} type="text" {...props} />;
};
